import { useMutation, useQueryClient } from 'react-query';

import { createTiltakEnergiplan } from '../../../../../services/api';
import { queryKeys } from '../../../../../utils/react-query';
import { Tiltak } from '../../../../../types/registration/tiltak';

export const useAddTiltak = (energiplanId: string | undefined) => {
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation((tiltak: Tiltak) => createTiltakEnergiplan({ ...tiltak, energiplanId }), {
    onSuccess: () => queryClient.invalidateQueries([queryKeys.energyplanMeasures, energiplanId])
  });

  return { addTiltak: mutate, isLoading };
};
